<template>
  <div>
      <el-row class="mt-2">
          <b class="font_extralarge">选择指定学员和课程进行导出</b>        
      </el-row>
      <!-- 第二部分，上传 -->
      <el-row class="mt-2">
          <b class="font_base">1. 输入学员</b>        
      </el-row>

      <el-row class="mt-2">
        <el-input
          v-model="users"
          :rows="3"
          type="textarea"
          placeholder="Please input"
        />
      </el-row>

      <el-row class="mt-2">
          <b class="font_base">2. 选择排课信息</b>        
      </el-row>

      <el-row class="mt-2">
        <el-input
          v-model="studyclasses"
          :rows="3"
          type="textarea"
          placeholder="Please input"
        />
      </el-row>


      <el-row>
          <el-button style="margin-top: 12px;" type="primary" @click="publish" :loading="loading">确认</el-button>
          <el-button style="margin-top: 12px;"  @click="onCancel" >AAA</el-button>
      </el-row>
  </div>
</template>

<script>
import { PersonSelect,SchedulingSelect } from "@/views/components/select"
import { usersApi,cancelApi } from "@/api/module/fillcheck/fillcheck"

export default {

  name : 'ExportArea',

  components:{
    PersonSelect,SchedulingSelect
  },

  data(){
    return {
      loading : false,
      users : "",
      studyclasses:"",
      jsondata : null,
      retired : false

    }
  },
  methods:{
    init(){
    },

    onSchedulingValChanged(val,item){
      this.selectSchedulings.push(item);
    },

    onRemoveSelectScheduling(index){
      this.selectSchedulings.splice(index,1)

    },

    publish(){

      if(this.loading){
        return;
      }

      this.loading = true;
      
      // if(uids.length == 0 && !jsondata){
      //   this.$message.error("需选择学员！");
      //   return;
      // }

      // if(sids.length == 0 && !jsondata){
      //   this.$message.error("需选择排课！");
      //   return;
      // }

      localStorage.setItem("export_area__users",this.users)
      localStorage.setItem("export_area__studyclasses",this.studyclasses)



      usersApi(this.users,this.studyclasses)
        .then((r)=>{

        })
        .finally(()=>{
          this.loading = false;
        })


    },


    onCancel(){
      if(this.loading){
        return;
      }

      this.loading = true;
      localStorage.setItem("export_area__users",this.users)
      localStorage.setItem("export_area__studyclasses",this.studyclasses)



      cancelApi(this.users,this.studyclasses)
        .then((res)=>{
            if(res.data.size > 0){
                let filename = "data.xls";
                let data = res.data;

                console.log("res.data",data.length)

                let url = window.URL.createObjectURL(new Blob([data]));
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click()    
            }
            else {
                ElMessage.error("导出错误");
            }
        })
        .finally(()=>{
          this.loading = false;
        })

    }
  },

  mounted(){
    this.users = localStorage.getItem("export_area__users");
    this.studyclasses = localStorage.getItem("export_area__studyclasses")
  },

  created() {

  }



}
</script>
<style scoped lang="scss">
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}

.select_user_row{
  margin-top: 0px;
  margin-bottom: 0px;

  max-height: 300px;
  overflow-y: auto;

  p {
    margin-top: 2px;
    margin-bottom: 2px;
  }
}
</style>